import React, { useState } from "react";
import InputText from "../utils/InputText";
import useShopStore from "../store/useShopStore";
import Button from "../utils/Button";
import classes from "./AddProduct.module.css";
import useAppStore from "../store/useAppStore";
import { toast } from "react-toastify";

export default function AddProduct() {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    price: "",
    tax: "",
    description: "",
    image: "",
  });

  const { addProduct } = useShopStore((state) => state);

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    const newFormData = { ...formData };
    newFormData[name] = value;

    if (name === "image") {
      newFormData.image = files[0];
    }

    setFormData(newFormData);
  };

  const handleAddProduct = (event) => {
    // Standardverhalten abbrechen
    event.preventDefault();

    // Daten als Formular aufbereiten
    const submitForm = new FormData();
    submitForm.append("name", formData.name);
    submitForm.append("category", formData.category);
    submitForm.append("price", formData.price);
    submitForm.append("description", formData.description);
    submitForm.append("tax", formData.tax);
    submitForm.append("image", formData.image);

    // an Zustand Methode senden
    addProduct(submitForm);
    setFormData({
      name: "",
      category: "",
      price: "",
      tax: "",
      description: "",
      image: "",
    });

    useAppStore.setState({
      notify: "Your Product has been added you can add next Product",
    });

    toast(useAppStore.getState().notify);
  };

  return (
    <>
      <form className={classes.form} onSubmit={handleAddProduct}>
        <InputText
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          type="text"
          name="name"
        />

        <select
          style={{
            padding: "1rem",
            border: "1px solid rgb(190, 190, 190)",
          }}
          onChange={handleChange}
          name="category"
        >
          <option>Beer</option>
          <option>Wine</option>
          <option>Spirits</option>
        </select>
        <InputText
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          type="text"
          name="description"
          required="required"
        />
        <InputText
          placeholder="Price"
          value={formData.price}
          onChange={handleChange}
          type="number"
          name="price"
          required="required"
        />
        <InputText
          placeholder="Tax"
          value={formData.tax}
          onChange={handleChange}
          type="number"
          name="tax"
          required="required"
        />
        <InputText
          style={{ display: "flex", flexDirection: "column" }}
          onChange={handleChange}
          type="file"
          name="image"
          required="required"
        />
        <Button
          style={{ width: "100%", gridColumn: "-3 -1" }}
          type="submit"
          onsubmit={handleAddProduct}
        >
          Add Product
        </Button>
      </form>
    </>
  );
}
